import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {
  AccountTitleAction,
  ContactAction,
  CostCenterAction,
  GeneralUtilsAction,
  HashtagAction,
  TransactionAction
} from "../actions";
import * as transactionApi from "../api/transaction";
import { toastr } from "react-redux-toastr";
import { go, goBack, push, replace } from "connected-react-router";
import { concatAllErrors, SetMessage } from "../assets/errorMessages";
import { createBrowserHistory } from "history";
import {
  IMPORT_DATA_FROM_FILE_STEPS,
  TRANSACTION_IMPORT_FILE_STEP_KEY,
  TRANSACTION_IMPORT_FILE_UUID
} from "../constants/transactions";

export function* watcherTransaction() {
  yield takeLatest(types.IMPORT_FILE_TRANSACTIONS_REQUEST, importFile);
  yield takeLatest(
    types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_REQUEST,
    createMissingObjectsForImportFile
  );
  yield takeLatest(
    types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST,
    getItemsOfImportedFile
  );
  yield takeLatest(
    types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST,
    storeItemsOfImportedFile
  );
}

function* importFile(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(importFileRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(TransactionAction.importFileSuccess(response.data)); // important: should be before change link
    if (
      Object.values(response.data.missing_objects).some(item => item.length > 0)
    ) {
      //check if there is at least one sub-item to create
      yield put(
        push({
          pathname: history.location.pathname,
          state: {
            [TRANSACTION_IMPORT_FILE_STEP_KEY]:
              IMPORT_DATA_FROM_FILE_STEPS.CREATE_MISSING_SUB_ITEMS
          }
        })
      );
    } else {
      yield put(
        push({
          pathname: history.location.pathname,
          state: {
            [TRANSACTION_IMPORT_FILE_STEP_KEY]:
              IMPORT_DATA_FROM_FILE_STEPS.FINAL_PREVIEW,
            [TRANSACTION_IMPORT_FILE_UUID]: response.data.uuid
          }
        })
      );
    }
    // yield put(TransactionAction.importFileSuccess(response.data));
  } catch (error) {
    if (error && error.response && error.response.status === 422) {
      yield put(
        GeneralUtilsAction.setModalDataForLongError({
          title: "خطای بارگذاری فایل اکسل",
          message: concatAllErrors(error)
        })
      );
    } else {
      SetMessage(error, true);
    }
    yield put(TransactionAction.importFileFailure());
  }
}
function importFileRequest(data) {
  return transactionApi.importFile(data);
}

function* createMissingObjectsForImportFile(action) {
  try {
    const history = createBrowserHistory();
    const response = yield call(
      createMissingObjectsForImportFileRequest,
      action.data
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(TransactionAction.createMissingObjectsForImportFileSuccess());
    yield put(
      replace({
        pathname: history.location.pathname,
        state: {
          [TRANSACTION_IMPORT_FILE_STEP_KEY]:
            IMPORT_DATA_FROM_FILE_STEPS.FINAL_PREVIEW,
          [TRANSACTION_IMPORT_FILE_UUID]: action.data.uuid
        }
      })
    );
    if (action.data.account_titles.length > 0) {
      yield put(AccountTitleAction.clearList());
    }
    if (action.data.cost_centers.length > 0) {
      yield put(CostCenterAction.clearList());
    }
    if (action.data.contacts.length > 0) {
      yield put(ContactAction.clearList());
    }
    if (action.data.hashtags.length > 0) {
      yield put(HashtagAction.clearList());
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(TransactionAction.createMissingObjectsForImportFileFailure());
  }
}
function createMissingObjectsForImportFileRequest(data) {
  return transactionApi.createMissingObjectsForImportFile(data);
}

function* getItemsOfImportedFile(action) {
  try {
    const response = yield call(getItemsOfImportedFileRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(
      TransactionAction.getItemsOfImportedFileSuccess(response.data.data)
    );
  } catch (error) {
    if (error.response.status === 404) {
      SetMessage(error, true);
    }
    const message = SetMessage(error);
    yield put(TransactionAction.getItemsOfImportedFileFailure(message));
  }
}
function getItemsOfImportedFileRequest(data) {
  return transactionApi.getItemsOfImportedFile(data);
}

function* storeItemsOfImportedFile(action) {
  try {
    const response = yield call(storeItemsOfImportedFileRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(TransactionAction.storeItemsOfImportedFileSuccess());
    yield put(go(-3));
  } catch (error) {
    SetMessage(error, true);
    yield put(TransactionAction.storeItemsOfImportedFileFailure());
  }
}
function storeItemsOfImportedFileRequest(data) {
  return transactionApi.storeItemsOfImportedFile(data);
}
